import type { ChipProps } from "@mui/material";
import { Chip } from "@mui/material";
import styles from "./styles.module.css";

interface Props extends ChipProps {
  className?: string;
}

export const AppChip = ({ className, ...rest }: Props) => {
  return (
    <Chip classes={{ label: styles.chip }} className={className} {...rest} />
  );
};
